module.exports = __webpack_public_path__ + "static/media/feature_ellipse_3.2b6d8eb6.png";